// frontend/src/components/CrearAreaModal.jsx
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import presupuestosService from '../services/presupuestosService';
import './CrearModal.css';

import Loading from './Loading';
const CrearAreaModal = ({ presupuestoId, onClose, onAreaAdded }) => {
  const [tab, setTab] = useState('existente');
  const [areas, setAreas] = useState([]);
  const [selectedAreaId, setSelectedAreaId] = useState('');
  const [formData, setFormData] = useState({
    equipo: '',
    nombre_area: '',
    status: 'activo'
  });
  const [equipos, setEquipos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    cargarDatos();
  }, []);

  const cargarDatos = async () => {
    try {
      const [areasRes, equiposRes] = await Promise.all([
        presupuestosService.getAreas(),
        presupuestosService.getEquipos()
      ]);

      let areasData = [];
      let equiposData = [];

      if (areasRes.data && areasRes.data.results && Array.isArray(areasRes.data.results)) {
        areasData = areasRes.data.results;
      } else if (Array.isArray(areasRes.data)) {
        areasData = areasRes.data;
      }

      if (equiposRes.data && equiposRes.data.results && Array.isArray(equiposRes.data.results)) {
        equiposData = equiposRes.data.results;
      } else if (Array.isArray(equiposRes.data)) {
        equiposData = equiposRes.data;
      }

      setAreas(areasData);
      setEquipos(equiposData);
      if (equiposData.length > 0) {
        setFormData(prev => ({
          ...prev,
          equipo: equiposData[0].id
        }));
      }
    } catch (error) {
      console.error('Error al cargar datos:', error);
      toast.error('Error al cargar datos');
      setAreas([]);
      setEquipos([]);
    } finally {
      setLoading(false);
    }
  };

  const handleAddExistente = (e) => {
    e.preventDefault();
    if (!selectedAreaId) {
      toast.error('Debes seleccionar un área');
      return;
    }
    const area = areas.find(a => a.id === parseInt(selectedAreaId));
    onAreaAdded(area);
  };

  const handleCreateNew = async (e) => {
    e.preventDefault();
    if (!formData.nombre_area.trim()) {
      toast.error('El nombre del área es requerido');
      return;
    }
    if (!formData.equipo) {
      toast.error('Debes seleccionar un equipo');
      return;
    }

    try {
      const response = await presupuestosService.createArea(formData);
      toast.success('Área creada exitosamente');
      onAreaAdded(response.data);
    } catch (error) {
      console.error('Error al crear área:', error);
      toast.error('Error al crear área');
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  if (loading) {
    return (
      <div className="modal-overlay" onClick={onClose}>
        <div className="modal-content modal-presupuesto" onClick={e => e.stopPropagation()}>
          <div className="modal-header">
            <h2>Agregar Área al Presupuesto</h2>
            <button className="close-btn" onClick={onClose}>✕</button>
          </div>
          <Loading fullScreen={false} size="sm" />
        </div>
      </div>
    );
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content modal-presupuesto" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Agregar Área al Presupuesto</h2>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>

        {/* Tabs modernos */}
        <div className="area-modal-tabs">
          <button
            className={`area-modal-tab ${tab === 'existente' ? 'active' : ''}`}
            onClick={() => setTab('existente')}
          >
            <span className="area-modal-tab-icon">📂</span>
            Área Existente
          </button>
          <button
            className={`area-modal-tab ${tab === 'crear' ? 'active' : ''}`}
            onClick={() => setTab('crear')}
          >
            <span className="area-modal-tab-icon">✨</span>
            Crear Nueva
          </button>
        </div>

        {/* Content */}
        {tab === 'existente' ? (
          <form onSubmit={handleAddExistente} className="presupuesto-form-modern">
            <div className="pf-section">
              <div className="pf-section-header">
                <span className="pf-section-icon">🔍</span>
                <h4>Seleccionar Área</h4>
              </div>
              <div className="pf-section-body">
                <div className="form-group">
                  <label className="pf-label">Área *</label>
                  <select
                    value={selectedAreaId}
                    onChange={(e) => setSelectedAreaId(e.target.value)}
                    required
                    className="form-control"
                  >
                    <option value="">Seleccionar un área...</option>
                    {Array.isArray(areas) && areas.map(area => (
                      <option key={area.id} value={area.id}>
                        {area.nombre_area} ({area.equipo_nombre})
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button type="button" className="btn-secondary" onClick={onClose}>
                Cancelar
              </button>
              <button type="submit" className="btn-primary">
                Agregar Área
              </button>
            </div>
          </form>
        ) : (
          <form onSubmit={handleCreateNew} className="presupuesto-form-modern">
            <div className="pf-section">
              <div className="pf-section-header">
                <span className="pf-section-icon">🏗️</span>
                <h4>Nueva Área</h4>
              </div>
              <div className="pf-section-body">
                <div className="form-group">
                  <label className="pf-label">Equipo *</label>
                  <select
                    name="equipo"
                    value={formData.equipo}
                    onChange={handleChange}
                    required
                    className="form-control"
                  >
                    <option value="">Seleccionar equipo...</option>
                    {Array.isArray(equipos) && equipos.map(equipo => (
                      <option key={equipo.id} value={equipo.id}>
                        {equipo.nombre_equipo}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="form-group">
                  <label className="pf-label">Nombre del Área *</label>
                  <input
                    type="text"
                    name="nombre_area"
                    value={formData.nombre_area}
                    onChange={handleChange}
                    placeholder="Ej: Diseño, Desarrollo, etc."
                    required
                    className="form-control"
                  />
                </div>

                <div className="form-group">
                  <label className="pf-label">Status</label>
                  <select
                    name="status"
                    value={formData.status}
                    onChange={handleChange}
                    className="form-control"
                  >
                    <option value="activo">Activo</option>
                    <option value="inactivo">Inactivo</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button type="button" className="btn-secondary" onClick={onClose}>
                Cancelar
              </button>
              <button type="submit" className="btn-primary">
                Crear Área
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default CrearAreaModal;
